import React, { useEffect } from 'react';
import { CloseRounded } from '@material-ui/icons';
import styles from './styles';
import { IconButton, CircularProgress } from '@material-ui/core';
import { Tooltip, Button } from '@material-ui/core';
import clsx from 'clsx';
import {
  deleteContainerImages,
  uploadContainerApproval,
  uploadContainerImages,
  deleteApprovalImages,
  SaveApiResMessage,
} from '@/actions';
import { Loading, useNotify } from 'react-admin';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import pdfImage from '../../../assets/img/pdf.png';
import { removeNoScroll } from '@/actions/Helper';
import SubmitButton from '@/ctComponents/submitButton';
import CloseButton from '@/ctComponents/closeButton';

export default ({
  Close,
  DATA,
  hasImage,
  orderStatus,
  chatType,
  orderID,
  containerID,
  index,
  updateFormApproveData,
  updateSelectedContainerImages,
  updateContainerApproval,
}) => {
  const cls = styles();
  const wrapperRef = React.useRef(null);
  // useOutsideAlerter(wrapperRef, () => {
  //   Close();
  // });
  // const notify = useNotify();
  const [loading, setLoading] = React.useState(false);
  const [images, setImages] = React.useState([]);
  const [uploadedImages, setUploadedImages] = React.useState([]);
  const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });
  const [draggedFileName, setDraggedFileName] = React.useState('');
  const [isDragging, setIsDragging] = React.useState(false);
  // useEffect(() => {
  // console.log('hiiiidata', DATA);
  // }, [DATA]);
  // console.log(
  //   'DATA?.inventory?.containers[index]?.images',
  //   DATA?.inventory?.containers[index]?.images
  // );
  React.useEffect(() => {
    if (hasImage) {
      setUploadedImages(
        hasImage === 'hasImage'
          ? images
          : hasImage === 'withImage'
          ? DATA?.selectedContainer?.images
          : hasImage === 'preApprovedImage'
          ? DATA?.preapprovedcontainer?.container?.images
          : hasImage === 'approvedImage' || hasImage === 'approvalFile'
          ? DATA?.preapprovedcontainer?.container?.approvals
          : DATA?.inventory?.containers[index]?.images
      );
    }
  }, [hasImage]);

  // console.log('uploadedImages', uploadedImages);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setMousePosition({ x: e.clientX, y: e.clientY });
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
    setDraggedFileName('Drop here');
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    if (!files.length) return;

    const allowedTypes = [
      'image/jpeg',
      'image/png',
      'image/jpg',
      'application/pdf', // Correct MIME type for PDFs
      'image/gif',
    ];

    const validFiles = files.filter((file) => {
      if (!allowedTypes.includes(file.type)) {
        // notify('You can only upload image files.', 'warning');
        SaveApiResMessage({
          title: 'Warning',
          message: 'You can only upload image files.',
          mode: 'warning',
        });
        return false;
      }
      if (file.size > 2000000) {
        // notify('You can upload IMG files less than 2MB.', 'warning');
        SaveApiResMessage({
          title: 'Warning',
          message: 'You can upload IMG files less than 2MB.',
          mode: 'warning',
        });
        return false;
      }
      return true;
    });

    if (validFiles.length + images.length + uploadedImages?.length > 5) {
      // notify('You can upload up to 5 images only.', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'You can upload up to 5 images only.',
        mode: 'warning',
      });
      return;
    }

    const newImages = validFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      size: file.size,
      progress: 0,
    }));
    console.log('newImages', newImages);

    // Check for duplicates in current queue (images)
    const filteredNewImages = newImages.filter(
      (newImage) =>
        !images.some(
          (existingImage) => existingImage.file.name === newImage.file.name
        )
    );

    // Check for duplicates in uploaded images from API
    const filteredFromUploadedImages = filteredNewImages.filter(
      (newImage) =>
        !uploadedImages.some(
          (existingImage) =>
            existingImage.image_name === newImage.file.name ||
            existingImage.file_name === newImage.file.name
        )
    );

    if (filteredFromUploadedImages.length > 0) {
      setImages((prevImages) => [...prevImages, ...filteredFromUploadedImages]);
    } else {
      // Get the names of duplicate files for error message
      const duplicateFiles = newImages.filter(
        (newImage) =>
          images.some(
            (existingImage) => existingImage.file.name === newImage.file.name
          ) ||
          uploadedImages.some(
            (existingImage) =>
              existingImage.image_name === newImage.file.name ||
              existingImage.file_name === newImage.file.name
          )
      );

      const duplicateNames = duplicateFiles.map((img) => img.file.name);
      const errorMessage =
        duplicateNames.length === 1
          ? `Image name "${duplicateNames[0]}" was already selected.`
          : `Image names "${duplicateNames.join(', ')}" were already selected.`;

      // notify(errorMessage);
      SaveApiResMessage({
        title: 'Warning',
        message: errorMessage,
        mode: 'warning',
      });
    }
    if (validFiles.length > 0) {
      setDraggedFileName(
        validFiles.length === 1 ? validFiles[0].name : 'Drop here'
      );
    }
  };

  const handleMouseMove = (e) => {
    setMousePosition({ x: e.clientX, y: e.clientY });
  };

  const handleRemoveImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    setImages(newImages);
  };

  const handleUpload = () => {
    if (images.length > 0) {
      setLoading(true);

      images.forEach((image, index) => {
        startUpload(index);
      });

      const payload = {
        container_id: DATA?.selectedContainerID,
        offer_id: orderID,
        images,
      };

      setTimeout(() => {
        uploadContainerImages(payload)
          .then((res) => {
            updateSelectedContainerImages(index, res);
            // notify(res.message, 'success');
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res.message,
              mode: 'success',
            });
            setLoading(false);
            Close();
            removeNoScroll();
          })
          .catch((err) => {
            // notify(err.message || 'Error when upload', 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err.message || 'Error when upload',
              mode: 'warning',
            });
            setLoading(false);
          });
        setLoading(false);
      }, 1500);
    } else if (uploadedImages?.length > 0) {
      Close();
      removeNoScroll();
    } else {
      // notify('Select Image(s) to upload', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'Select Image(s) to upload',
        mode: 'warning',
      });
    }
  };

  const handleDelete = (id, st) => {
    setLoading(true);
    const url = st !== 3 ? deleteContainerImages : deleteApprovalImages;
    url(id)
      .then((res) => {
        // notify(res.message, 'success');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res.message,
          mode: 'success',
        });
        setLoading(false);
        setUploadedImages((prevImages) =>
          prevImages.filter((image) => image.id !== id)
        );
        st !== 3
          ? updateSelectedContainerImages(
              index,
              { data: { container_id: containerID, image_id: id } },
              'delete'
            )
          : updateContainerApproval(
              index,
              { data: { container_id: containerID, approval_id: id } },
              'delete'
            );
      })
      .catch((err) => {
        // notify(err.message || 'Error when upload', 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err.message || 'Error when upload',
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const handleUploadApproval = () => {
    if (uploadedImages?.length > 0) {
      setLoading(true);
      updateFormApproveData(index, 'approve_status', 1);
      updateFormApproveData(index, 'container_id', containerID);
      updateFormApproveData(index, 'offer_id', orderID);
      setLoading(false);
    }
    if (images.length > 0) {
      setLoading(true);

      images.forEach((image, index) => {
        startUpload(index);
      });
      // console.log('orderID', orderID);

      const payload = {
        orderID,
        container_id: containerID,
        offer_id: orderID,
        images,
      };
      setTimeout(() => {
        uploadContainerApproval(payload)
          .then((res) => {
            updateContainerApproval(index, res);
            updateFormApproveData(index, 'approve_status', 1);
            updateFormApproveData(index, 'container_id', containerID);
            // notify(res.message, 'success');
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res.message,
              mode: 'success',
            });
            setLoading(false);
            Close();
            removeNoScroll();
          })
          .catch((err) => {
            // notify(err.message || 'Error when upload', 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err.message || 'Error when upload',
              mode: 'warning',
            });
            setLoading(false);
            removeNoScroll();
          });
      }, 1500);
    } else if (uploadedImages?.length > 0) {
      Close();
      removeNoScroll();
    } else {
      // notify('Select File(s) to upload', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'Select File(s) to upload',
        mode: 'warning',
      });
    }
  };

  const handleAddImage = (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const allowedTypes = [
      'image/jpeg',
      'image/png',
      'image/jpg',
      'image/gif',
      'application/pdf', // Correct MIME type for PDFs
      'image/svg+xml',
    ];

    const validFiles = files.filter((file) => {
      if (!allowedTypes.includes(file.type)) {
        // notify('You can only upload image files.', 'warning');
        SaveApiResMessage({
          title: 'Warning',
          message: 'You can only upload image files.',
          mode: 'warning',
        });
        return false;
      }
      if (file.size > 2000000) {
        // notify('You can upload IMG files less than 2MB.', 'warning');
        SaveApiResMessage({
          title: 'Warning',
          message: 'You can upload IMG files less than 2MB.',
          mode: 'warning',
        });
        return false;
      }
      return true;
    });

    if (validFiles?.length + images?.length + uploadedImages?.length > 5) {
      // notify('You can upload up to 5 images only.', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'You can upload up to 5 images only.',
        mode: 'warning',
      });
      return;
    }

    const newImages = validFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      size: file.size,
      progress: 0,
    }));

    // Check for duplicates in current queue (images)
    const filteredNewImages = newImages.filter(
      (newImage) =>
        !images.some(
          (existingImage) => existingImage.file.name === newImage.file.name
        )
    );

    // Check for duplicates in uploaded images from API
    const filteredFromUploadedImages = filteredNewImages.filter(
      (newImage) =>
        !uploadedImages.some(
          (existingImage) =>
            existingImage.image_name === newImage.file.name ||
            existingImage.file_name === newImage.file.name
        )
    );

    if (filteredFromUploadedImages.length > 0) {
      setImages((prevImages) => [...prevImages, ...filteredFromUploadedImages]);
    } else {
      // Get the names of duplicate files for error message
      const duplicateFiles = newImages.filter(
        (newImage) =>
          images.some(
            (existingImage) => existingImage.file.name === newImage.file.name
          ) ||
          uploadedImages.some(
            (existingImage) =>
              existingImage.image_name === newImage.file.name ||
              existingImage.file_name === newImage.file.name
          )
      );

      const duplicateNames = duplicateFiles.map((img) => img.file.name);
      const errorMessage =
        duplicateNames.length === 1
          ? `Image name "${duplicateNames[0]}" was already selected.`
          : `Image names "${duplicateNames.join(', ')}" were already selected.`;

      // notify(errorMessage);
      SaveApiResMessage({
        title: 'Warning',
        message: errorMessage,
        mode: 'warning',
      });
    }
  };
  console.log('uploadedImages', uploadedImages);

  const startUpload = (index) => {
    const speedPerSecond = 1000;
    const fileSize = images[index]?.size || 0;
    const duration = speedPerSecond;
    const step = 100 / (duration / 100);

    const interval = setInterval(() => {
      setImages((prevImages) => {
        const updatedImages = [...prevImages];
        const currentProgress = updatedImages[index]?.progress || 0;

        if (currentProgress >= 100) {
          clearInterval(interval);
        } else {
          updatedImages[index].progress = Math.min(currentProgress + step, 100);
        }

        return updatedImages;
      });
    }, 200);
  };

  const formatFileSize = (sizeInBytes) => {
    if (sizeInBytes < 1024) {
      return `${sizeInBytes} B`;
    } else if (sizeInBytes < 1024 * 1024) {
      return `${(sizeInBytes / 1024).toFixed(0)} KB`;
    } else {
      return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
    }
  };

  return (
    <div className={cls.popup}>
      <div className={cls.uploadImageCard}>
        <Tooltip arrow title="Close" placement="top">
          <CloseRounded className={cls.closeP} onClick={Close} />
        </Tooltip>
        <div ref={wrapperRef} className={cls.popupCard}>
          <span className={cls.tableTopActions}>
            <ReactSVG
              src={Icons.galleryAddBlack}
              className={cls.dicsounticon}
            />
            {hasImage === 'approvalFile'
              ? 'Approval Upload'
              : hasImage === 'approvedImage'
              ? 'Approval files'
              : 'Container Image Upload'}
          </span>
          <span>
            {hasImage === 'approvalFile'
              ? 'You will need to upload your approval file to complete the confirmation process.'
              : 'Add your pictures here, and you can upload up to 5 pictures max.'}
          </span>
          {
            <div className={cls.uploadedImagesDiv}>
              {(Array.isArray(uploadedImages)
                ? uploadedImages
                : Object.values(uploadedImages)
              ).map((image, index) => (
                <div key={index} className={cls.uploadedImagePreviewDiv}>
                  <span className={cls.imagePreviewInfoSection}>
                    <img
                      src={
                        image.file_name?.toLowerCase().endsWith('.pdf')
                          ? pdfImage
                          : hasImage === 'approvedImage' ||
                            hasImage === 'approvalFile'
                          ? image.fileSrc
                          : image.imgSrc
                      }
                      alt={`Preview ${index}`}
                      className={cls.imagePreviewImg}
                    />
                    <span className={cls.imagePreviewInfo}>
                      <Tooltip
                        arrow
                        title={
                          image.file_name?.toLowerCase().endsWith('.pdf')
                            ? image.file_name
                            : hasImage === 'approvedImage' ||
                              hasImage === 'approvalFile'
                            ? image.file_name
                            : image?.image_name
                        }
                        placement="top">
                        <span className={cls.UploadedmagePreviewName}>
                          {image.file_name?.toLowerCase().endsWith('.pdf')
                            ? image.file_name
                            : hasImage === 'approvedImage' ||
                              hasImage === 'approvalFile'
                            ? image.file_name
                            : image?.image_name}
                        </span>
                      </Tooltip>
                      <span className={cls.UploadeImageIcons}>
                        {(chatType === 'offer' && orderStatus.value === 1) ||
                        (chatType !== 'offer' &&
                          orderStatus.value === 3 &&
                          hasImage === 'approvalFile') ? (
                          <span
                            onClick={() =>
                              handleDelete(image.id, orderStatus.value)
                            }
                            className={cls.uploadedImageRemoveIcon}>
                            <ReactSVG src={Icons.xCircle} />
                            Delete
                          </span>
                        ) : (
                          ''
                        )}
                        <span
                          onClick={() =>
                            window.open(
                              image.file_name?.toLowerCase().endsWith('.pdf')
                                ? image?.fileSrc
                                : hasImage === 'approvedImage' ||
                                  hasImage === 'approvalFile'
                                ? image.fileSrc
                                : image?.imgSrc,
                              '_blank'
                            )
                          }
                          className={cls.uploadedImageViewIcon}>
                          <ReactSVG src={Icons?.imageView} />
                          View
                        </span>
                      </span>
                    </span>
                  </span>
                </div>
              ))}
            </div>
          }
          {hasImage === 'preApprovedImage' ||
          hasImage === 'approvedImage' ||
          hasImage === 'approvalFile' ? (
            ''
          ) : hasImage === 'hasImage' || uploadedImages?.length <= 5 ? (
            <>
              <div
                className={cls.imageUploadSection}
                // onDragOver={(e) => e.preventDefault()}
                // onDragLeave={() => setIsDragging(false)}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                // onDrop={handleDrop}
                onMouseMove={handleMouseMove}
                style={{
                  // border: isDragging ? '2.5px dashed #FFE097' : '2px dashed #ccc',
                  // padding: '20px',
                  // borderRadius: '8px',
                  // textAlign: 'center',
                  // cursor: 'pointer',
                  backgroundColor: isDragging ? '#FEF7E8' : '#fff',
                  transition: 'background-color 0.2s ease',
                }}>
                <ReactSVG
                  src={Icons.imageUpload}
                  className={cls.imageUploadIcon}
                />
                <span className={cls.imageUploadArea}>
                  <span className={cls.dragDropText}>
                    Drag & Drop your files
                  </span>
                  <span className={cls.dragDropOrText}>
                    <span className={cls.orHr} />
                    <span>OR</span>
                    <span className={cls.orHr} />
                  </span>
                  <div>
                    <label className={cls.browFilesBtn} htmlFor="file-input">
                      Browse files
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      accept="image/*,application/pdf"
                      multiple
                      style={{ display: 'none' }}
                      onChange={handleAddImage}
                    />
                  </div>
                </span>
              </div>
              <span className={cls.fileTypeInfo}>
                Only support .jpg and .png files less then 2MB
              </span>
              <div className={cls.uploadedImagesDiv}>
                {images?.map((image, index) => (
                  <div key={index} className={cls.uploadedImagePreviewDiv}>
                    <span className={cls.imagePreviewInfoSection}>
                      <img
                        src={
                          image.file.type === 'application/pdf'
                            ? pdfImage
                            : image.preview
                        }
                        alt={`Preview ${index}`}
                        className={cls.imagePreviewImg}
                      />
                      <span className={cls.imagePreviewInfo}>
                        <Tooltip
                          arrow
                          title={image?.file?.name}
                          placement="top">
                          <span className={cls.UploadedmagePreviewName}>
                            {image?.file?.name}
                          </span>
                        </Tooltip>
                        <span className={cls.SelectedImageIcons}>
                          <span>{formatFileSize(image?.file?.size)}</span>
                          <IconButton
                            onClick={() => handleRemoveImage(index)}
                            className={cls.removeIcon}>
                            <ReactSVG
                              src={Icons.xCircle}
                              className={cls.imageRemoveIcon}
                            />
                          </IconButton>
                        </span>
                        <div
                          style={{
                            width: '106%',
                            height: '5px',
                            backgroundColor: '#fff',
                            // borderRadius: '3px',
                            position: 'relative',
                            overflow: 'hidden',
                            marginBottom: '-4px',
                            marginLeft: '-6px',
                          }}>
                          <div
                            style={{
                              width: `${image.progress}%`,
                              height: '500px',
                              background: `linear-gradient(to right, #3b82f6,rgb(168, 206, 253))`,
                              transition: 'width 0.2s linear',
                            }}
                          />
                        </div>
                      </span>
                    </span>
                  </div>
                ))}
              </div>
              {isDragging && draggedFileName && (
                <div
                  style={{
                    position: 'fixed',
                    bottom: mousePosition.y + 10,
                    left: mousePosition.x + 10,
                    backgroundColor: '#FEF7E8',
                    border: '1px solid #FFAD00',
                    color: '#131517',
                    padding: '8px 12px',
                    borderRadius: '50px',
                    zIndex: 1000,
                    pointerEvents: 'none',
                    fontSize: '14px',
                  }}>
                  {draggedFileName}
                </div>
              )}{' '}
            </>
          ) : (
            ''
          )}
          {hasImage === 'approvalFile' ? (
            <>
              <div
                className={cls.imageUploadSection}
                // onDragOver={(e) => e.preventDefault()}
                // onDragLeave={() => setIsDragging(false)}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                // onDrop={handleDrop}
                onMouseMove={handleMouseMove}
                style={{
                  // border: isDragging ? '2.5px dashed #FFE097' : '2px dashed #ccc',
                  // padding: '20px',
                  // borderRadius: '8px',
                  // textAlign: 'center',
                  // cursor: 'pointer',
                  backgroundColor: isDragging ? '#FEF7E8' : '#fff',
                  transition: 'background-color 0.2s ease',
                }}>
                <ReactSVG
                  src={Icons.imageUpload}
                  className={cls.imageUploadIcon}
                />
                <span className={cls.imageUploadArea}>
                  <span className={cls.dragDropText}>
                    Drag & Drop your files
                  </span>
                  <span className={cls.dragDropOrText}>
                    <span className={cls.orHr} />
                    <span>OR</span>
                    <span className={cls.orHr} />
                  </span>
                  <div>
                    <label className={cls.browFilesBtn} htmlFor="file-input">
                      Browse files
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      accept="image/*,application/pdf"
                      multiple
                      style={{ display: 'none' }}
                      onChange={handleAddImage}
                    />
                  </div>
                </span>
              </div>
              <span className={cls.fileTypeInfo}>
                Only support .jpg, .png and pdf files less then 3MB
              </span>
              <div className={cls.uploadedImagesDiv}>
                {images?.map((image, index) => (
                  <div key={index} className={cls.uploadedImagePreviewDiv}>
                    <span className={cls.imagePreviewInfoSection}>
                      <img
                        src={
                          image.file.type === 'application/pdf'
                            ? pdfImage
                            : image.preview
                        }
                        alt={`Preview ${index}`}
                        className={cls.imagePreviewImg}
                      />
                      <span className={cls.imagePreviewInfo}>
                        <Tooltip
                          arrow
                          title={image?.file?.name}
                          placement="top">
                          <span className={cls.UploadedmagePreviewName}>
                            {image?.file?.name}
                          </span>
                        </Tooltip>
                        <span className={cls.SelectedImageIcons}>
                          <span>{formatFileSize(image?.file?.size)}</span>
                          <IconButton
                            onClick={() => handleRemoveImage(index)}
                            className={cls.removeIcon}>
                            <ReactSVG
                              src={Icons.xCircle}
                              className={cls.imageRemoveIcon}
                            />
                          </IconButton>
                        </span>

                        {/* <span>{formatFileSize(image?.file?.size)}</span> */}
                        <div
                          style={{
                            width: '106%',
                            height: '5px',
                            backgroundColor: '#fff',
                            // borderRadius: '3px',
                            position: 'relative',
                            overflow: 'hidden',
                            marginBottom: '-4px',
                            marginLeft: '-6px',
                          }}>
                          <div
                            style={{
                              width: `${image.progress}%`,
                              height: '500px',
                              background: `linear-gradient(to right, #3b82f6,rgb(168, 206, 253))`,
                              transition: 'width 0.2s linear',
                            }}
                          />
                        </div>
                      </span>
                    </span>
                  </div>
                ))}
              </div>
              {isDragging && draggedFileName && (
                <div
                  style={{
                    position: 'fixed',
                    bottom: mousePosition.y + 10,
                    left: mousePosition.x + 10,
                    backgroundColor: '#FEF7E8',
                    border: '1px solid #FFAD00',
                    color: '#131517',
                    padding: '8px 12px',
                    borderRadius: '50px',
                    zIndex: 1000,
                    pointerEvents: 'none',
                    fontSize: '14px',
                  }}>
                  {draggedFileName}
                </div>
              )}{' '}
            </>
          ) : (
            ''
          )}
        </div>
        <div className={cls.msgPopupBtns} style={{ marginTop: '20px' }}>
          <CloseButton color="#131517" onClick={() => Close()} text="Cancel" />

          {hasImage === 'approvedImage' ? (
            ''
          ) : loading ? (
            <SubmitButton loading={loading} onClick={() => {}} text="Confirm" />
          ) : hasImage === 'preApprovedImage' ? (
            ''
          ) : hasImage === 'approvalFile' ? (
            <SubmitButton
              onClick={() => handleUploadApproval()}
              text="Confirm"
            />
          ) : (
            <SubmitButton onClick={() => handleUpload()} text="Submit" />
          )}
        </div>
      </div>
    </div>
    //test
  );
};
